module.exports = __webpack_public_path__ + "static/media/v2.62dd2af7.mp4";